import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { createTravel } from '../services/travels.service';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';

const vehicleOptions = [
  { key: 'turismo', emoji: '🚗', label: 'Turismo', desc: 'Hasta 4 bultos' },
  { key: 'moto', emoji: '🏍️', label: 'Moto', desc: 'Pequeños paquetes' },
  { key: 'furgoneta', emoji: '🚐', label: 'Furgoneta', desc: 'Grande y espaciosa' },
];

const steps = ['ruta', 'cuando', 'vehiculo', 'mensaje'];
const stepLabels = ['Ruta', 'Cuándo', 'Vehículo', 'Mensaje'];

export default function NewTravel({ onBack, onTabChange, onOpenPackage }) {
  const { token } = useAuth();
  const [step, setStep] = useState(0);
  const [departurePlace, setDeparturePlace] = useState('');
  const [arrivalPlace, setArrivalPlace] = useState('');
  const [vehicleType, setVehicleType] = useState('turismo');
  const [departureDate, setDepartureDate] = useState('');
  const [arrivalDate, setArrivalDate] = useState('');
  const [mensajePersonal, setMensajePersonal] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const canNext = () => {
    if (step === 0) return departurePlace.trim() && arrivalPlace.trim();
    return true;
  };

  const handleNext = () => {
    setError('');
    if (step === 0 && (!departurePlace.trim() || !arrivalPlace.trim())) {
      setError('Indica el origen y el destino');
      return;
    }
    if (step < steps.length - 1) setStep(step + 1);
    else handleSubmit();
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const city = (place) => place.split(',')[0].trim();
      await createTravel({
        from: city(departurePlace),
        to: city(arrivalPlace),
        vehicleType,
        capacityKg: 0,
        departureDate: departureDate || null,
        departurePlace,
        arrivalDate: arrivalDate || null,
        arrivalPlace,
        mensajePersonal,
        pickupRadiusKm: 0,
        dropoffRadiusKm: 0
      }, token);
      setSuccess(true);
    } catch (err) {
      setError('Error publicando el viaje: ' + err.message);
    }
    setLoading(false);
  };

  if (success) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0d0f14', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px', textAlign: 'center' }}>
      <div style={{ fontSize: '64px', marginBottom: '20px', animation: 'bounce 0.6s ease' }}>🙌</div>
      <h2 style={{ color: 'white', fontWeight: '800', fontSize: '26px', marginBottom: '10px', letterSpacing: '-0.02em' }}>
        ¡Viaje publicado!
      </h2>
      <p style={{ color: '#9ca3af', fontSize: '14px', lineHeight: '1.7', maxWidth: '280px', marginBottom: '6px' }}>
        Ya pueden pedirte ayuda quienes necesiten enviar algo en tu ruta.
      </p>
      <p style={{ color: '#f97316', fontSize: '13px', fontStyle: 'italic', marginBottom: '36px' }}>
        Cada viaje, una oportunidad de ayudar 🤝
      </p>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button onClick={onBack}
          style={{ backgroundColor: '#f97316', color: 'white', fontWeight: '700', padding: '14px 28px', borderRadius: '14px', fontSize: '14px', border: 'none', cursor: 'pointer' }}>
          Volver al inicio
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0d0f14', paddingBottom: '96px' }}>
      <Navbar onBack={onBack} onOpenPackage={onOpenPackage} />

      {/* Fondo decorativo */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: '250px',
        background: 'radial-gradient(ellipse 70% 40% at 50% -10%, #f9731610 0%, transparent 70%)',
        pointerEvents: 'none', zIndex: 0,
      }} />

      <div style={{ maxWidth: '480px', margin: '0 auto', padding: '20px 16px', position: 'relative', zIndex: 1 }}>

        {/* Header */}
        <div style={{ marginBottom: '28px' }}>
          <p style={{ color: '#6b7280', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '6px' }}>
            Nuevo viaje
          </p>
          <h1 style={{ color: 'white', fontWeight: '800', fontSize: '28px', letterSpacing: '-0.02em', lineHeight: '1.1', marginBottom: '6px' }}>
            ¿Adónde vas?
          </h1>
          <p style={{ color: '#f97316', fontSize: '12px', fontStyle: 'italic' }}>
            Comparte tu ruta y ayuda a quien lo necesite 🤝
          </p>
        </div>

        {/* Stepper */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0', marginBottom: '28px' }}>
          {steps.map((s, i) => (
            <React.Fragment key={s}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                <div onClick={() => i < step && setStep(i)} style={{
                  width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  backgroundColor: i < step ? '#f97316' : i === step ? '#f9731620' : '#1a1d24',
                  border: `2px solid ${i <= step ? '#f97316' : '#2a2d35'}`,
                  cursor: i < step ? 'pointer' : 'default',
                  transition: 'all 0.2s',
                }}>
                  {i < step
                    ? <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                    : <span style={{ color: i === step ? '#f97316' : '#4b5563', fontSize: '11px', fontWeight: '700' }}>{i + 1}</span>
                  }
                </div>
                <span style={{ color: i === step ? '#f97316' : i < step ? '#9ca3af' : '#3a3d45', fontSize: '9px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  {stepLabels[i]}
                </span>
              </div>
              {i < steps.length - 1 && (
                <div style={{ flex: 1, height: '2px', backgroundColor: i < step ? '#f97316' : '#2a2d35', margin: '0 4px', marginBottom: '16px', transition: 'background-color 0.3s' }} />
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Card */}
        <div style={{ backgroundColor: '#1a1d24', border: '1px solid #2a2d35', borderRadius: '24px', padding: '24px', marginBottom: '16px' }}>

          {/* PASO 0: Ruta */}
          {step === 0 && (
            <div>
              <p style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '20px' }}>📍 Tu ruta</p>
              
              <div style={{ position: 'relative' }}>
                {/* Línea conectora */}
                <div style={{ position: 'absolute', left: '19px', top: '52px', width: '2px', height: '32px', backgroundColor: '#2a2d35', zIndex: 0 }} />
                
                <div style={{ marginBottom: '8px', position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                    <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#22c55e', flexShrink: 0, marginLeft: '5px', boxShadow: '0 0 8px #22c55e60' }} />
                    <label style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '600' }}>ORIGEN</label>
                  </div>
                  <input
                    placeholder="¿Desde dónde sales? — Granada, Estación..."
                    value={departurePlace}
                    onChange={e => { setDeparturePlace(e.target.value); setError(''); }}
                    style={{ backgroundColor: '#13161c', border: '1px solid #2a2d35', color: 'white', borderRadius: '14px', padding: '14px 16px', fontSize: '14px', width: '100%', outline: 'none' }}
                    className="placeholder-gray-600"
                  />
                </div>

                <div style={{ position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                    <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#f97316', flexShrink: 0, marginLeft: '5px', boxShadow: '0 0 8px #f9731660' }} />
                    <label style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '600' }}>DESTINO</label>
                  </div>
                  <input
                    placeholder="¿Hasta dónde vas? — Madrid, Aeropuerto..."
                    value={arrivalPlace}
                    onChange={e => { setArrivalPlace(e.target.value); setError(''); }}
                    style={{ backgroundColor: '#13161c', border: '1px solid #2a2d35', color: 'white', borderRadius: '14px', padding: '14px 16px', fontSize: '14px', width: '100%', outline: 'none' }}
                    className="placeholder-gray-600"
                  />
                </div>
              </div>

              {/* Preview ruta */}
              {departurePlace && arrivalPlace && (
                <div style={{ marginTop: '16px', backgroundColor: '#f9731608', border: '1px solid #f9731620', borderRadius: '12px', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ color: '#22c55e', fontSize: '12px', fontWeight: '700' }}>{departurePlace.split(',')[0]}</span>
                  <span style={{ color: '#f97316', fontSize: '14px' }}>→</span>
                  <span style={{ color: '#f97316', fontSize: '12px', fontWeight: '700' }}>{arrivalPlace.split(',')[0]}</span>
                </div>
              )}
            </div>
          )}

          {/* PASO 1: Cuándo */}
          {step === 1 && (
            <div>
              <p style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '20px' }}>🕐 Cuándo viajas</p>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div>
                  <label style={{ color: '#6b7280', fontSize: '12px', fontWeight: '600', display: 'block', marginBottom: '8px' }}>
                    Fecha y hora de salida
                  </label>
                  <input
                    type="datetime-local"
                    value={departureDate}
                    onChange={e => setDepartureDate(e.target.value)}
                    style={{ backgroundColor: '#13161c', border: '1px solid #2a2d35', color: 'white', borderRadius: '14px', padding: '14px 16px', fontSize: '14px', width: '100%', outline: 'none', colorScheme: 'dark' }}
                  />
                </div>
                <div>
                  <label style={{ color: '#6b7280', fontSize: '12px', fontWeight: '600', display: 'block', marginBottom: '8px' }}>
                    Hora estimada de llegada <span style={{ color: '#3a3d45', fontWeight: '400' }}>(opcional)</span>
                  </label>
                  <input
                    type="time"
                    value={arrivalDate}
                    onChange={e => setArrivalDate(e.target.value)}
                    style={{ backgroundColor: '#13161c', border: '1px solid #2a2d35', color: 'white', borderRadius: '14px', padding: '14px 16px', fontSize: '14px', width: '100%', outline: 'none', colorScheme: 'dark' }}
                  />
                </div>
              </div>

              <div style={{ marginTop: '16px', backgroundColor: '#3b82f608', border: '1px solid #3b82f620', borderRadius: '12px', padding: '12px 14px' }}>
                <p style={{ color: '#6b7280', fontSize: '12px', lineHeight: '1.5' }}>
                  💡 Si aún no sabes la fecha exacta puedes dejarlo en blanco y editarlo después.
                </p>
              </div>
            </div>
          )}

          {/* PASO 2: Vehículo */}
          {step === 2 && (
            <div>
              <p style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '20px' }}>🚗 Tu vehículo</p>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {vehicleOptions.map(opt => (
                  <button key={opt.key} onClick={() => setVehicleType(opt.key)}
                    style={{
                      backgroundColor: vehicleType === opt.key ? '#f9731612' : '#13161c',
                      border: `2px solid ${vehicleType === opt.key ? '#f97316' : '#2a2d35'}`,
                      borderRadius: '16px', padding: '16px 18px',
                      display: 'flex', alignItems: 'center', gap: '14px',
                      cursor: 'pointer', transition: 'all 0.15s', textAlign: 'left', width: '100%',
                    }}>
                    <span style={{ fontSize: '28px' }}>{opt.emoji}</span>
                    <div>
                      <p style={{ color: vehicleType === opt.key ? '#f97316' : 'white', fontWeight: '700', fontSize: '15px', marginBottom: '2px' }}>{opt.label}</p>
                      <p style={{ color: '#6b7280', fontSize: '12px' }}>{opt.desc}</p>
                    </div>
                    {vehicleType === opt.key && (
                      <div style={{ marginLeft: 'auto', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                      </div>
                    )}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* PASO 3: Mensaje */}
          {step === 3 && (
            <div>
              <p style={{ color: '#9ca3af', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '8px' }}>💬 Tu mensaje</p>
              <p style={{ color: '#6b7280', fontSize: '12px', lineHeight: '1.5', marginBottom: '16px' }}>
                Un mensaje cercano genera más confianza. Cuéntanos brevemente tu viaje.
              </p>
              
              <textarea
                placeholder="Ej: Buenas! Viajo a Barcelona el sábado y aún tengo hueco en el coche, si alguien necesita mandar algo estoy disponible 🙌"
                value={mensajePersonal}
                onChange={e => setMensajePersonal(e.target.value.slice(0, 300))}
                rows={5}
                style={{ backgroundColor: '#13161c', border: '1px solid #2a2d35', color: 'white', borderRadius: '14px', padding: '14px 16px', fontSize: '13px', width: '100%', outline: 'none', resize: 'none', lineHeight: '1.6' }}
                className="placeholder-gray-600"
              />
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                <p style={{ color: '#3a3d45', fontSize: '11px' }}>Opcional pero recomendado</p>
                <p style={{ color: mensajePersonal.length > 250 ? '#f97316' : '#3a3d45', fontSize: '11px' }}>{mensajePersonal.length}/300</p>
              </div>

              {/* Resumen del viaje */}
              <div style={{ marginTop: '20px', backgroundColor: '#13161c', border: '1px solid #2a2d35', borderRadius: '16px', padding: '16px' }}>
                <p style={{ color: '#6b7280', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '12px' }}>Resumen del viaje</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280', fontSize: '13px' }}>Ruta</span>
                    <span style={{ color: 'white', fontSize: '13px', fontWeight: '600' }}>{departurePlace.split(',')[0]} → {arrivalPlace.split(',')[0]}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280', fontSize: '13px' }}>Vehículo</span>
                    <span style={{ color: 'white', fontSize: '13px', fontWeight: '600' }}>{vehicleOptions.find(v => v.key === vehicleType)?.emoji} {vehicleOptions.find(v => v.key === vehicleType)?.label}</span>
                  </div>
                  {departureDate && (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: '#6b7280', fontSize: '13px' }}>Salida</span>
                      <span style={{ color: 'white', fontSize: '13px', fontWeight: '600' }}>{new Date(departureDate).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {error && (
            <div style={{ backgroundColor: '#ff000015', border: '1px solid #ff000030', color: '#f87171', borderRadius: '10px', padding: '10px 14px', fontSize: '13px', marginTop: '16px' }}>
              {error}
            </div>
          )}
        </div>

        {/* Botones */}
        <div style={{ display: 'flex', gap: '10px' }}>
          {step > 0 && (
            <button onClick={() => setStep(step - 1)}
              style={{ backgroundColor: '#1a1d24', border: '1px solid #2a2d35', color: '#9ca3af', fontWeight: '600', padding: '14px 20px', borderRadius: '14px', fontSize: '14px', cursor: 'pointer' }}>
              ← Atrás
            </button>
          )}
          <button onClick={handleNext} disabled={loading || !canNext()}
            style={{
              backgroundColor: canNext() ? '#f97316' : '#2a2d35',
              flex: 1, color: canNext() ? 'white' : '#4b5563',
              fontWeight: '700', padding: '14px', borderRadius: '14px', fontSize: '14px',
              border: 'none', cursor: canNext() && !loading ? 'pointer' : 'default',
              transition: 'all 0.2s',
            }}>
            {loading ? 'Publicando...' : step === steps.length - 1 ? '🚀 Publicar viaje' : 'Continuar →'}
          </button>
        </div>

        <p style={{ color: '#2a2d35', fontSize: '11px', textAlign: 'center', marginTop: '16px' }}>
          Quienes necesiten ayuda en tu ruta podrán contactarte 🤝
        </p>
      </div>

      <BottomNav active="home" onChange={onTabChange} unreadCount={0} />
    </div>
  );
}